module.exports = __webpack_public_path__ + "static/media/odm-logo-title.5019f1b0.png";